let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eBptL")).then(() => parcelRequire('2yAmG'));